import styled from 'styled-components';
import { BoldBodyText } from 'ui-toolkit/components/Typography';

export const AmountText = styled(BoldBodyText)`
  text-align: right;
  padding-right: ${(props) => props.theme.spacing.roomyContentPaddingValue * 2}px;
`;
